import { formulaNew } from "../../formula/formulaNew";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_197: DocMigration = {
  maxSchemaVersion: "0.0.197",
  description: "Remove bottom field from window descriptor",
  apply(json: any) {
    //collet all bottom values from window catalogs

    //bottom values from default window catalog
    const windowCatalogBottom = {
      A1840: 48,
      A2040: 48,
      A3030: 36,
      A4040: 48,
      A2046: 34,
      A2640: 48,
      A71046: 34,
      A2030: 22,
      A2080: 2,
      A2050: 22,
      A2060: 22,
      A2550: 22,
      A2650: 22,
      A3040: 34,
      A3040_TEMP: 34,
      A3046: 34,
      A3050: 34,
      A3050_BRICK: 34,
      A3050_TEMP: 34,
      A3850: 34,
      A4050: 22,
      A5050: 34,
      A2860: 22,
      A3060: 36,
      A4060: 22,
      A5060: 22,
      A31080: 2,
      A4080: 2,
      A5080: 2,
      A31090: 2,
      A4090: 2,
      A5090: 2,
      TW2636: 48,
      TW2640: 48,
      TW2646: 48,
      TW2650: 34,
      TW3020: 34,
      TW3050: 34,
      TW3050_TEMP_HALF: 34,
      TW3060: 22,
      TW3080: 2,
      TW4080: 2,
      TR2640: 34,
      TR2650: 34,
      TR2660: 34,
      TR3050: 34,
      TR3060: 22,
      TR2050: 22,
      TR2030: 2,
      TR2020: 2,
      TR3080: 2,
      TR13880: 2,
      TR13890: 2,
      T1: 34,
      T2: 80,
      T2620: 80,
      T3620: 80,
      T3010: 80,
      T2010: 80,
      T4010: 80,
      T5010: 80,
      T6010: 80,
      T6020: 80,
      T8010: 80,
      T2020: 68,
      T2020_LOW: 12,
      TW2220: 68,
      TW2040: 30,
      G1620: 12,
      G2020: 12,
      G2030: 12,
      G2436: 12,
      G2040: 12,
      G3040: 12,
      G6630: 6,
      S1: 24,
      S2: 12,
      SL1: 0.5,
      D6020: 12,
      V2020: 0,
      V0808: 0,
      V1: 0,
      V1020: 0,
      V0912: 0,
      V1220: 0,
      V1620: 0,
      V1824: 0,
      NO: 0,
      K1: 40,
      D1: 12,
    };

    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type !== "WINDOW_CATALOG_SETTINGS") {
        continue;
      }
      for (const windowTypeId in setting.windowTypes) {
        const windowType = setting.windowTypes[windowTypeId];
        let windowBottom = 0;
        if (windowType.bottom !== undefined) {
          windowBottom = windowType.bottom;
          delete windowType.bottom;
        }
        windowCatalogBottom[windowTypeId] = windowBottom;
      }
    }

    //add former bottom value to vertical offset
    //gable openings
    for (const gableOpeningId in json.gableOpenings) {
      const gableOpening = json.gableOpenings[gableOpeningId];
      if (gableOpening.justification === "PEAK_DOWN") {
        continue;
      }
      const windowTypeBottom = windowCatalogBottom[gableOpening.windowType];
      if (!windowTypeBottom) {
        continue;
      }
      if (gableOpening.offset) {
        const openingOffset = gableOpening.offset;
        const openingOffsetVal = openingOffset.type === "FORMULA" ? openingOffset.formula : openingOffset.toString();
        const formula = openingOffsetVal + " + " + windowTypeBottom.toString();
        gableOpening.offset = formulaNew(formula);
      } else {
        const offsetFormula = formulaNew(windowTypeBottom.toString());
        gableOpening.offset = offsetFormula;
      }
    }

    //dormer openings
    for (const dormerOpeningId in json.dormers) {
      const dormerOpening = json.dormers[dormerOpeningId];
      const dormerWindowType = dormerOpening.windowType ?? "G2030";
      const windowTypeBottom = windowCatalogBottom[dormerWindowType];
      const verticalOffset = dormerOpening.windowVerticalOffset;
      dormerOpening.windowVerticalOffset = verticalOffset ? verticalOffset + windowTypeBottom : windowTypeBottom;

      //dormer gable opening
      if (dormerOpening.gableOpeningPlacement) {
        const dormerGableOpening = dormerOpening.gableOpeningPlacement;
        if (dormerGableOpening.justification === "PEAK_DOWN") {
          continue;
        }
        if (dormerGableOpening.windowType) {
          const windowTypeBottom = windowCatalogBottom[dormerGableOpening.windowType];
          if (dormerGableOpening.offset) {
            dormerGableOpening.offset += windowTypeBottom;
          } else {
            dormerGableOpening.offset = windowTypeBottom;
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_197;
